<script setup>
  import { ref } from 'vue';
  import ExploremoreLcCat from './exploremore-lc-cat.vue'
  import "@/styles/css/learning-center.scss";
  const view = ref(false)
  const openView = () => {
    view.value = true
  }
</script>
<template>

  <div class="container-learning-center page-container" style="margin-top: 70px;">
    <section class="lc_completeToc">
      <section class="learning-center_banner">
        <div class="visible-lg visible-md visible-sm">
          <picture>
            <source srcset="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-ipo.webp"
              type="image/webp">
            <img title="IPO" alt="ipo"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-ipo.png">
          </picture>
        </div>
        <div class="visible-xs">
          <picture>
            <source srcset="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-ipo-mobile.webp"
              type="image/webp">
            <img alt="ipo" src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-ipo-mobile.png">
          </picture>

        </div>
      </section>

      <section class="toc_container LC-article">
        <div class="container-fluid ht-page faq">
          <div class="">
            <div class="lc-cat-toc-wraper">
              <h1 class="curr-tax">IPO</h1><br>
              <p class="curr-tax-desc">Why do companies go public? Learn how to invest in an IPO.
              </p>
            </div>
            <div class="lc-cat-toc-wraper">
              <p class="toc-txt">TABLE OF CONTENTS</p>
              <ul class="lc-category-page-wrapper hidden-md hidden-lg">

                <li class="LC-toc-list">
                  <h2>
                    <a id="1"
                      href="/learning-center/ipo/list-of-upcoming-ipos-in-india-new-ipo-launch/">List
                      of Upcoming IPOs in India - New IPO Launch</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="2"
                      href="/learning-center/ipo/what-is-a-secondary-offering-ipo-meaning-types/">What
                      is a Secondary Offering IPO: Meaning &amp; Types</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="3" href="/learning-center/ipo/what-is-roadshow-in-ipo/">What is Roadshow in
                      IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="4"
                      href="/learning-center/ipo/venture-capital-backed-ipo-definition-example-explained/">Venture
                      Capital-Backed IPO: Definition, Example, &amp; Explained</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="5"
                      href="/learning-center/ipo/what-is-the-difference-between-equity-ipo-vs-debt-ipo/">What
                      is the Difference Between Equity IPO vs Debt IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="6"
                      href="/learning-center/ipo/qualified-institutional-buyers-qibs-in-ipo-in-india-definition/">Qualified
                      Institutional Buyers (QIBs) in IPO in India: Definition</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="7"
                      href="/learning-center/ipo/what-is-hot-ipo-and-how-does-it-work-meaning-and-examples/">What
                      is Hot IPO and How Does it Work: Meaning and Examples</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="8"
                      href="/learning-center/ipo/what-is-ipo-grading-process-in-india-meaning/">What
                      is IPO Grading Process in India: Meaning</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="9"
                      href="/learning-center/ipo/what-is-difference-between-ipo-and-fpo-in-share-market/">What
                      is Difference Between IPO and FPO in Share Market</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="10" href="/learning-center/ipo/what-is-an-ipo-margin-funding-meaning/">What
                      is an IPO Margin Funding: Meaning</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="11" href="/learning-center/ipo/what-is-an-ipo-advisor-meaning/">What is an
                      IPO Advisor: Meaning</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="12"
                      href="/learning-center/ipo/pre-ipo-stock-investing-in-india-how-does-it-work-and-why-is-it-important/">Pre-IPO
                      Stock Investing in India: How Does it Work and Why is it Important?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="13"
                      href="/learning-center/ipo/how-to-analysis-of-ipo-and-investment-factors-to-consider/">How
                      to Analysis of IPO and Investment Factors to Consider</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="14"
                      href="/learning-center/ipo/what-is-a-shelf-prospectus-criteria-and-how-can-it-benefit-an-investor/">What
                      is a Shelf Prospectus, Criteria and How Can it Benefit an Investor?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="15"
                      href="/learning-center/ipo/syndicate-member-role-in-ipo-types-and-syndication-risk/">Syndicate
                      Member: Role in IPO, Types and Syndication Risk</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="16"
                      href="/learning-center/ipo/what-is-asba-full-form-benefits-and-detailed-application-process/">What
                      is ASBA? Full Form, Benefits and Detailed Application Process</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="17"
                      href="/learning-center/ipo/how-to-buy-ipo-online-steps-benefits-and-eligibility-criteria/">How
                      to Buy IPO Online - Steps, Benefits and Eligibility Criteria</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="18"
                      href="/learning-center/ipo/best-tips-for-investing-in-ipo-to-beginners-and-investors/">Tips
                      for Investing in IPO to Beginners and Investors</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="19"
                      href="/learning-center/ipo/what-is-deemed-prospectus-meaning-types-importance/">Deemed
                      Prospectus: Definition, Components and Examples</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="20"
                      href="/learning-center/ipo/drhp-full-form-draft-red-herring-prospectus-meaning/">Draft
                      Red Herring Prospectus (DRHP) : Components, Importance and More</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="21"
                      href="/learning-center/ipo/what-is-rhp-red-herring-prospectus-meaning-importance/">What
                      is Red Herring Prospectus (RHP) and How Important is It?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="22"
                      href="/learning-center/ipo/what-is-investment-in-non-convertible-debentures-meaning-and-types/">What
                      is NCD (Non Convertible Debentures)?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="23" href="/learning-center/ipo/when-to-apply-in-ipo-ncd-ofs-and-nfo/">When
                      To Apply In IPO, NCD, OFS And NFO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="24"
                      href="/learning-center/ipo/what-is-ipo-prospectus-and-why-is-it-important/">What
                      Is IPO Prospectus And Why Is It Important</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="25"
                      href="/learning-center/ipo/what-is-process-of-initial-public-offering-ipo-meaning-and-advantages/">Initial
                      Public Offering: All You Need To Know About IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="26" href="/learning-center/ipo/how-to-apply-ipo-in-minor-account/">How To
                      Apply For An IPO In A Minor's Name</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="27"
                      href="/learning-center/ipo/why-do-companies-go-public-meaning-and-advantages/">Why
                      Do Companies Go Public and Importance</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="28"
                      href="/learning-center/ipo/different-types-of-investors-in-ipo-in-india/">Different
                      Types Of IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="29"
                      href="/learning-center/ipo/what-is-ipo-in-share-stock-market-meaning/">What Is
                      IPO In Stock Market</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="30"
                      href="/learning-center/ipo/explain-and-define-the-ipo-process-in-india/">IPO
                      Process</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="31"
                      href="/learning-center/ipo/ipo-for-beginners-and-how-to-choose-best-ipo-for-investment/">IPO
                      For Beginners</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="32" href="/learning-center/ipo/how-is-ipo-priced-or-valued/">How is IPO
                      Priced or Valued?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="33"
                      href="/learning-center/ipo/what-is-grey-market-premium-gmp-in-ipo/">Grey Market
                      Premium (GMP) IPO - What It Is, Meaning, &amp; Full Form</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="34"
                      href="/learning-center/ipo/ipo-application-methods-apply-ipo-through-asba/">IPO
                      Application Methods: Apply IPO Through ASBA</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="35"
                      href="/learning-center/ipo/ipo-application-methods-apply-ipo-through-upi/">UPI
                      IPO Application - Apply IPO Through UPI</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="36" href="/learning-center/ipo/is-investing-in-ipo-good-or-bad/">Investing
                      in IPO is Good or Bad</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="37"
                      href="/learning-center/ipo/differences-between-ipo-direct-listing/">Differences
                      Between IPO &amp; Direct Listing</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="38"
                      href="/learning-center/ipo/what-is-difference-between-small-gain-capital-gain/">What
                      is Difference Between Small Gain &amp; Capital Gain?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="39" href="/learning-center/ipo/what-is-flipping-in-ipo/">What is Flipping
                      in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="40"
                      href="/learning-center/ipo/what-is-the-difference-between-fixed-price-issue-book-building-issue/">What
                      is the Difference Between Fixed Price Issue &amp; Book Building Issue?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="41" href="/learning-center/ipo/what-is-the-issue-price-in-ipo/">What is the
                      Issue Price in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="42"
                      href="/learning-center/ipo/why-is-it-necessary-to-have-a-pan-card-to-apply-ipo/">Why
                      is it Necessary to have a Pan Card to Apply IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="43"
                      href="/learning-center/ipo/what-is-market-lot-size-minimum-order-quantity-in-ipo/">What
                      is Market Lot Size &amp; Minimum Order Quantity in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="44" href="/learning-center/ipo/what-is-ipo-cycle-explain-the-process/">What
                      is IPO Cycle? Explain the Process</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="45" href="/learning-center/ipo/types-of-investors-in-ipo/">Types of
                      Investors In IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="46"
                      href="/learning-center/ipo/what-is-difference-between-ipo-and-ofs/">What is
                      Difference Between IPO and OFS?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="47" href="/learning-center/ipo/what-is-difference-between-ofs-fpo/">What is
                      Difference Between OFS &amp; FPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="48" href="/learning-center/ipo/ipo-calendar-india-year-2022-2023/">IPO
                      Calendar in India 2022 - 2023</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="49" href="/learning-center/ipo/how-to-apply-for-an-ipo/">How to Apply for
                      an IPO Online &amp; Offline</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="50" href="/learning-center/ipo/what-is-percentage-gain-and-process/">What
                      Is Percentage Gain in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="51" href="/learning-center/ipo/what-is-pre-ipo-investing/">What is Pre-IPO
                      Investing?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="52" href="/learning-center/ipo/what-is-the-lock-in-period-in-ipo/">What is
                      the Lock-in Period in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="53" href="/learning-center/ipo/what-is-an-undersubscribed-ipo/">What is an
                      undersubscribed IPO?&nbsp;</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="54" href="/learning-center/ipo/what-are-ipo-requirements-in-india/">What
                      are IPO Requirements in India?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="55" href="/learning-center/ipo/what-is-oversubscription-in-ipo/">What Is
                      Oversubscription In IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="56" href="/learning-center/ipo/what-is-face-value-in-ipo/">What Is Face
                      Value in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="57"
                      href="/learning-center/ipo/how-is-an-ipo-initial-public-offering-priced/">How Is
                      An IPO (Initial Public Offering) Priced?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="58"
                      href="/learning-center/ipo/what-is-dp-name-in-the-ipo-application/">What is DP
                      name in the IPO application?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="59" href="/learning-center/ipo/what-are-drhp-and-rhp-in-ipo/">What are DRHP
                      and RHP in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="60"
                      href="/learning-center/ipo/how-to-invest-in-ipo-and-benefits-of-investing-in-ipos/">How
                      to Invest in IPO &amp; Benefits of Investing in IPOs?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="61" href="/learning-center/ipo/what-is-book-building/">What Is Book
                      building?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="62" href="/learning-center/ipo/what-is-greenshoe-option-in-ipo/">What is
                      Greenshoe Option in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="63"
                      href="/learning-center/ipo/what-is-ipo-subscription-and-process-of-how-to-subscribe-for-an-ipo/">IPO
                      Subscription Status - Details &amp; How to Check</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="64" href="/learning-center/ipo/what-is-ipo-listing/">What is IPO
                      Listing?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="65" href="/learning-center/ipo/what-is-ipo-listing-gain/">What is IPO
                      Listing Gain ?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="66" href="/learning-center/ipo/what-is-pre-apply-in-ipo/">What is Pre-Apply
                      in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="67" href="/learning-center/ipo/what-is-fpo-in-ipo-and-how-to-apply/">What
                      is FPO in IPO, and How to Apply?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="68" href="/learning-center/ipo/what-is-ofs-in-ipo-and-how-to-apply/">What
                      is OFS in IPO, and How to Apply?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="69" href="/learning-center/ipo/pros-cons-of-ipo/">Pros &amp; Cons of
                      IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="70" href="/learning-center/ipo/how-to-launch-ipo-in-india/">How to Launch
                      IPO in India?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="71" href="/learning-center/ipo/price-band-in-ipo/">Price Band in IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="72" href="/learning-center/ipo/what-is-lot-size-in-an-ipo/">What is Lot
                      size in an IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="73"
                      href="/learning-center/ipo/what-are-the-popular-terminologies-of-ipo/">What are
                      the Popular Terminologies of IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="74" href="/learning-center/ipo/what-is-cut-off-price-in-ipo/">What is
                      Cut-Off Price in IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="75"
                      href="/learning-center/ipo/what-is-dpo-and-how-is-it-different-from-ipo/">What
                      is DPO and How is it different from IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="76" href="/learning-center/ipo/what-is-sme-ipo/">SME IPO - Subscription
                      Status, Details, Meaning, &amp; How to Apply</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="77" href="/learning-center/ipo/ipo-allotment-status/">IPO Allotment
                      Status</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="78"
                      href="/learning-center/ipo/things-to-check-before-investing-in-ipos/">Things to
                      Check Before Investing in IPOs</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="79" href="/learning-center/ipo/upcoming-ipos-in-india-2022/">Upcoming IPOs
                      in India 2022</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="80" href="/learning-center/ipo/the-basics-of-ipos/">The Basics of IPOs</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="81" href="/learning-center/ipo/how-to-buy-an-ipo-online/">How to Buy an IPO
                      Online in India</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="82" href="/learning-center/ipo/ipo-valuation-in-depth-guide/">IPO valuation
                      in-depth guide</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="83" href="/learning-center/ipo/types-of-ipos/">Types of IPOs</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="84" href="/learning-center/ipo/ipo-allotment-basics/">IPO allotment
                      basics</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="85" href="/learning-center/ipo/what-are-the-advantages-of-an-ipo/">What are
                      the advantages of an IPO?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="86" href="/learning-center/ipo/how-does-an-ipo-work/">How Does an IPO Work
                      for Investors in India</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="87" href="/learning-center/ipo/how-to-invest-in-an-ipo/">How to invest in
                      an IPO</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="88"
                      href="/learning-center/ipo/initial-public-offering-process-in-detail/">Initial
                      Public Offering process in detail</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="89" href="/learning-center/ipo/what-is-an-ipo-exit-route/">What is an IPO
                      exit route?</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="90" href="/learning-center/ipo/why-companies-go-public/">Why companies go
                      public</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="91" href="/learning-center/ipo/ipo-investment-tips-strategies/">IPO
                      investment - Tips and Strategies</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="92" href="/learning-center/ipo/ipo-guidelines-for-beginners/">IPO
                      guidelines for beginners</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="93" href="/learning-center/ipo/ipo-basics/">IPO basics</a>
                  </h2>
                </li>
                <!-- <div id="showall-posts">Show All</div>
                <div class="scroll-down" id="scroll-d">
                  <img alt="Scroll Down" src="https://upstox.com/app/themes/upstox/dist/img/learning_center/scroll.png">
                </div> -->
              </ul>
              <ul class="lc-category-page-wrapper hidden-xs hidden-sm">

                <li class="LC-toc-list">
                  <h2>
                    <a id="1"
                      href="/learning-center/ipo/list-of-upcoming-ipos-in-india-new-ipo-launch/">
                      List of Upcoming IPOs in India - New IPO Launch </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="2"
                      href="/learning-center/ipo/what-is-a-secondary-offering-ipo-meaning-types/">
                      What is a Secondary Offering IPO: Meaning &amp; Types </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="3" href="/learning-center/ipo/what-is-roadshow-in-ipo/">
                      What is Roadshow in IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="4"
                      href="/learning-center/ipo/venture-capital-backed-ipo-definition-example-explained/">
                      Venture Capital-Backed IPO: Definition, Example, &amp; Explained </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="5"
                      href="/learning-center/ipo/what-is-the-difference-between-equity-ipo-vs-debt-ipo/">
                      What is the Difference Between Equity IPO vs Debt IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="6"
                      href="/learning-center/ipo/qualified-institutional-buyers-qibs-in-ipo-in-india-definition/">
                      Qualified Institutional Buyers (QIBs) in IPO in India: Definition </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="7"
                      href="/learning-center/ipo/what-is-hot-ipo-and-how-does-it-work-meaning-and-examples/">
                      What is Hot IPO and How Does it Work: Meaning and Examples </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="8"
                      href="/learning-center/ipo/what-is-ipo-grading-process-in-india-meaning/">
                      What is IPO Grading Process in India: Meaning </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="9"
                      href="/learning-center/ipo/what-is-difference-between-ipo-and-fpo-in-share-market/">
                      What is Difference Between IPO and FPO in Share Market </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="10" href="/learning-center/ipo/what-is-an-ipo-margin-funding-meaning/">
                      What is an IPO Margin Funding: Meaning </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="11" href="/learning-center/ipo/what-is-an-ipo-advisor-meaning/">
                      What is an IPO Advisor: Meaning </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="12"
                      href="/learning-center/ipo/pre-ipo-stock-investing-in-india-how-does-it-work-and-why-is-it-important/">
                      Pre-IPO Stock Investing in India: How Does it Work and Why is it Important? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="13"
                      href="/learning-center/ipo/how-to-analysis-of-ipo-and-investment-factors-to-consider/">
                      How to Analysis of IPO and Investment Factors to Consider </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="14"
                      href="/learning-center/ipo/what-is-a-shelf-prospectus-criteria-and-how-can-it-benefit-an-investor/">
                      What is a Shelf Prospectus, Criteria and How Can it Benefit an Investor? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="15"
                      href="/learning-center/ipo/syndicate-member-role-in-ipo-types-and-syndication-risk/">
                      Syndicate Member: Role in IPO, Types and Syndication Risk </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="16"
                      href="/learning-center/ipo/what-is-asba-full-form-benefits-and-detailed-application-process/">
                      What is ASBA? Full Form, Benefits and Detailed Application Process </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="17"
                      href="/learning-center/ipo/how-to-buy-ipo-online-steps-benefits-and-eligibility-criteria/">
                      How to Buy IPO Online - Steps, Benefits and Eligibility Criteria </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="18"
                      href="/learning-center/ipo/best-tips-for-investing-in-ipo-to-beginners-and-investors/">
                      Tips for Investing in IPO to Beginners and Investors </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="19"
                      href="/learning-center/ipo/what-is-deemed-prospectus-meaning-types-importance/">
                      Deemed Prospectus: Definition, Components and Examples </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="20"
                      href="/learning-center/ipo/drhp-full-form-draft-red-herring-prospectus-meaning/">
                      Draft Red Herring Prospectus (DRHP) : Components, Importance and More </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="21"
                      href="/learning-center/ipo/what-is-rhp-red-herring-prospectus-meaning-importance/">
                      What is Red Herring Prospectus (RHP) and How Important is It? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="22"
                      href="/learning-center/ipo/what-is-investment-in-non-convertible-debentures-meaning-and-types/">
                      What is NCD (Non Convertible Debentures)? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="23" href="/learning-center/ipo/when-to-apply-in-ipo-ncd-ofs-and-nfo/">
                      When To Apply In IPO, NCD, OFS And NFO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="24"
                      href="/learning-center/ipo/what-is-ipo-prospectus-and-why-is-it-important/">
                      What Is IPO Prospectus And Why Is It Important </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="25"
                      href="/learning-center/ipo/what-is-process-of-initial-public-offering-ipo-meaning-and-advantages/">
                      Initial Public Offering: All You Need To Know About IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="26" href="/learning-center/ipo/how-to-apply-ipo-in-minor-account/">
                      How To Apply For An IPO In A Minor's Name </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="27"
                      href="/learning-center/ipo/why-do-companies-go-public-meaning-and-advantages/">
                      Why Do Companies Go Public and Importance </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="28"
                      href="/learning-center/ipo/different-types-of-investors-in-ipo-in-india/">
                      Different Types Of IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="29" href="/learning-center/ipo/what-is-ipo-in-share-stock-market-meaning/">
                      What Is IPO In Stock Market </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="30"
                      href="/learning-center/ipo/explain-and-define-the-ipo-process-in-india/">
                      IPO Process </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="31"
                      href="/learning-center/ipo/ipo-for-beginners-and-how-to-choose-best-ipo-for-investment/">
                      IPO For Beginners </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="32" href="/learning-center/ipo/how-is-ipo-priced-or-valued/">
                      How is IPO Priced or Valued? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="33" href="/learning-center/ipo/what-is-grey-market-premium-gmp-in-ipo/">
                      Grey Market Premium (GMP) IPO - What It Is, Meaning, &amp; Full Form </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="34"
                      href="/learning-center/ipo/ipo-application-methods-apply-ipo-through-asba/">
                      IPO Application Methods: Apply IPO Through ASBA </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="35"
                      href="/learning-center/ipo/ipo-application-methods-apply-ipo-through-upi/">
                      UPI IPO Application - Apply IPO Through UPI </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="36" href="/learning-center/ipo/is-investing-in-ipo-good-or-bad/">
                      Investing in IPO is Good or Bad </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="37" href="/learning-center/ipo/differences-between-ipo-direct-listing/">
                      Differences Between IPO &amp; Direct Listing </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="38"
                      href="/learning-center/ipo/what-is-difference-between-small-gain-capital-gain/">
                      What is Difference Between Small Gain &amp; Capital Gain? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="39" href="/learning-center/ipo/what-is-flipping-in-ipo/">
                      What is Flipping in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="40"
                      href="/learning-center/ipo/what-is-the-difference-between-fixed-price-issue-book-building-issue/">
                      What is the Difference Between Fixed Price Issue &amp; Book Building Issue? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="41" href="/learning-center/ipo/what-is-the-issue-price-in-ipo/">
                      What is the Issue Price in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="42"
                      href="/learning-center/ipo/why-is-it-necessary-to-have-a-pan-card-to-apply-ipo/">
                      Why is it Necessary to have a Pan Card to Apply IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="43"
                      href="/learning-center/ipo/what-is-market-lot-size-minimum-order-quantity-in-ipo/">
                      What is Market Lot Size &amp; Minimum Order Quantity in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="44" href="/learning-center/ipo/what-is-ipo-cycle-explain-the-process/">
                      What is IPO Cycle? Explain the Process </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="45" href="/learning-center/ipo/types-of-investors-in-ipo/">
                      Types of Investors In IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="46" href="/learning-center/ipo/what-is-difference-between-ipo-and-ofs/">
                      What is Difference Between IPO and OFS? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="47" href="/learning-center/ipo/what-is-difference-between-ofs-fpo/">
                      What is Difference Between OFS &amp; FPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="48" href="/learning-center/ipo/ipo-calendar-india-year-2022-2023/">
                      IPO Calendar in India 2022 - 2023 </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="49" href="/learning-center/ipo/how-to-apply-for-an-ipo/">
                      How to Apply for an IPO Online &amp; Offline </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="50" href="/learning-center/ipo/what-is-percentage-gain-and-process/">
                      What Is Percentage Gain in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="51" href="/learning-center/ipo/what-is-pre-ipo-investing/">
                      What is Pre-IPO Investing? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="52" href="/learning-center/ipo/what-is-the-lock-in-period-in-ipo/">
                      What is the Lock-in Period in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="53" href="/learning-center/ipo/what-is-an-undersubscribed-ipo/">
                      What is an undersubscribed IPO?&nbsp; </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="54" href="/learning-center/ipo/what-are-ipo-requirements-in-india/">
                      What are IPO Requirements in India? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="55" href="/learning-center/ipo/what-is-oversubscription-in-ipo/">
                      What Is Oversubscription In IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="56" href="/learning-center/ipo/what-is-face-value-in-ipo/">
                      What Is Face Value in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="57"
                      href="/learning-center/ipo/how-is-an-ipo-initial-public-offering-priced/">
                      How Is An IPO (Initial Public Offering) Priced? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="58" href="/learning-center/ipo/what-is-dp-name-in-the-ipo-application/">
                      What is DP name in the IPO application? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="59" href="/learning-center/ipo/what-are-drhp-and-rhp-in-ipo/">
                      What are DRHP and RHP in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="60"
                      href="/learning-center/ipo/how-to-invest-in-ipo-and-benefits-of-investing-in-ipos/">
                      How to Invest in IPO &amp; Benefits of Investing in IPOs? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="61" href="/learning-center/ipo/what-is-book-building/">
                      What Is Book building? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="62" href="/learning-center/ipo/what-is-greenshoe-option-in-ipo/">
                      What is Greenshoe Option in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="63"
                      href="/learning-center/ipo/what-is-ipo-subscription-and-process-of-how-to-subscribe-for-an-ipo/">
                      IPO Subscription Status - Details &amp; How to Check </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="64" href="/learning-center/ipo/what-is-ipo-listing/">
                      What is IPO Listing? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="65" href="/learning-center/ipo/what-is-ipo-listing-gain/">
                      What is IPO Listing Gain ? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="66" href="/learning-center/ipo/what-is-pre-apply-in-ipo/">
                      What is Pre-Apply in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="67" href="/learning-center/ipo/what-is-fpo-in-ipo-and-how-to-apply/">
                      What is FPO in IPO, and How to Apply? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="68" href="/learning-center/ipo/what-is-ofs-in-ipo-and-how-to-apply/">
                      What is OFS in IPO, and How to Apply? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="69" href="/learning-center/ipo/pros-cons-of-ipo/">
                      Pros &amp; Cons of IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="70" href="/learning-center/ipo/how-to-launch-ipo-in-india/">
                      How to Launch IPO in India? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="71" href="/learning-center/ipo/price-band-in-ipo/">
                      Price Band in IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="72" href="/learning-center/ipo/what-is-lot-size-in-an-ipo/">
                      What is Lot size in an IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="73" href="/learning-center/ipo/what-are-the-popular-terminologies-of-ipo/">
                      What are the Popular Terminologies of IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="74" href="/learning-center/ipo/what-is-cut-off-price-in-ipo/">
                      What is Cut-Off Price in IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="75"
                      href="/learning-center/ipo/what-is-dpo-and-how-is-it-different-from-ipo/">
                      What is DPO and How is it different from IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="76" href="/learning-center/ipo/what-is-sme-ipo/">
                      SME IPO - Subscription Status, Details, Meaning, &amp; How to Apply </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="77" href="/learning-center/ipo/ipo-allotment-status/">
                      IPO Allotment Status </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="78" href="/learning-center/ipo/things-to-check-before-investing-in-ipos/">
                      Things to Check Before Investing in IPOs </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="79" href="/learning-center/ipo/upcoming-ipos-in-india-2022/">
                      Upcoming IPOs in India 2022 </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="80" href="/learning-center/ipo/the-basics-of-ipos/">
                      The Basics of IPOs </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="81" href="/learning-center/ipo/how-to-buy-an-ipo-online/">
                      How to Buy an IPO Online in India </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="82" href="/learning-center/ipo/ipo-valuation-in-depth-guide/">
                      IPO valuation in-depth guide </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="83" href="/learning-center/ipo/types-of-ipos/">
                      Types of IPOs </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="84" href="/learning-center/ipo/ipo-allotment-basics/">
                      IPO allotment basics </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="85" href="/learning-center/ipo/what-are-the-advantages-of-an-ipo/">
                      What are the advantages of an IPO? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="86" href="/learning-center/ipo/how-does-an-ipo-work/">
                      How Does an IPO Work for Investors in India </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="87" href="/learning-center/ipo/how-to-invest-in-an-ipo/">
                      How to invest in an IPO </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="88" href="/learning-center/ipo/initial-public-offering-process-in-detail/">
                      Initial Public Offering process in detail </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="89" href="/learning-center/ipo/what-is-an-ipo-exit-route/">
                      What is an IPO exit route? </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="90" href="/learning-center/ipo/why-companies-go-public/">
                      Why companies go public </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="91" href="/learning-center/ipo/ipo-investment-tips-strategies/">
                      IPO investment - Tips and Strategies </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="92" href="/learning-center/ipo/ipo-guidelines-for-beginners/">
                      IPO guidelines for beginners </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="93" href="/learning-center/ipo/ipo-basics/">
                      IPO basics </a>
                  </h2>
                </li>
                <!-- <div id="showall-posts">Show All</div> -->
              </ul>
            </div>
          </div>
          <div class="lc-toc-container">
          </div>
        </div>
      </section>
      <div id="showall-article" class="showall-article hidden-md hidden-lg">
        Table of contents
      </div>
    </section>
    <exploremoreLcCat></exploremoreLcCat>
  </div>
</template>
<style scoped>
</style>